import { IMongoIndex } from '../../interfaces/mongo-index.interface';

export interface IWorkspace extends IMongoIndex {
    name: string;
}
